<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-form-model
      :model="formInline"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      @submit="handleSubmit"
      @submit.native.prevent
    >
      <a-row>
        <a-col :span="12"> 基本信息 </a-col>
      </a-row>
      <!-- <a-row>
        <a-col :span="11">
          <a-form-model-item label="活动门店">
            <a-input v-model="formInline.name" placeholder="请输入活动名称">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row> -->
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="封面图">
            <a-upload :customRequest="upload">
              <a-button type="primary"> 上传 </a-button>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="活动标题">
            <a-input
              v-model="formInline.activityTitle"
              placeholder="请输入活动名称"
            >
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="活动时间">
            <a-range-picker @change="onChange"
              :placeholder="[formInline.startTime, formInline.endTime]"
            format="YYYY-MM-DD HH:mm:ss" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="显示序号">
            <a-input v-model="formInline.sortNum" placeholder="请输入活动名称">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
              <a-row>
        <a-col :span="11">
          <a-form-model-item label="报名人数总人数">
            <a-input v-model="formInline.numberLimit" placeholder="请输入报名人数总人数">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="是否为报名活动">
            <a-switch
              @change="Change"
              checked-children="开"
              un-checked-children="关"
              default-checked
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <div
        :style="{
          padding: '24px',
          margin: '24px 16px 24px 16px',
          background: '#fff',
          minHeight: '100px',
        }"
      >
        <h1>活动内容</h1>
        <a-divider />
        <a-row>
          <a-icon type="snippets" />
          <a-icon type="font-colors" />
          <a-icon type="bold" />
          <a-icon type="italic" />
        </a-row>
        <a-row>
          <a-textarea
            v-model="formInline.activityContent"
            placeholder="Basic usage"
            :rows="4"
          />
        </a-row>
      </div>
      <!-- <a-row>
        <a-col :span="11">
          <a-form-model-item label="套餐有效期">
            <a-input v-model="formInline.user" placeholder="请输入活动名称">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row> -->
    </a-form-model>
    <a-table :columns="columns" :data-source="data" v-if="show"> </a-table>
    <a-button @click="save">保存</a-button>
    <a-button @click="goBack">返回</a-button>
  </div>
</template>

<script>
import {
  picUpload,
  detailsManageList,
  editManageList,
} from "@/api/storeApi.js";
import { number } from "echarts";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "Age",

    dataIndex: "name",
    key: "name",
    slots: { title: "customTitle" },
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Tags",
    key: "tags",
    dataIndex: "tags",
    scopedSlots: { customRender: "tags" },
  },
  {
    title: "Action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park",
    tags: ["nice", "developer"],
  },
];
// import chooseAnItem from "./chooseAnItem.vue";
export default {
  components: {
    // chooseAnItem,
  },
  data() {
    return {
      value: "",
      priceShop: "",
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      formInline: {
        activityTitle: "",
        activityContent: "",
        endTime: "",
        isApply: "",
        sortNum: "",
        surfacePlot: "",
        startTime: "",
        id: "",
        numberLimit:'',
      },
      data,
      columns,
      show: false,
    };
  },
  mounted() {
    this.getDetailsManageList();
    this.formInline.id = this.$route.query.id;
  },
  methods: {
    upload(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error("请确保图片大小在2M以内");
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          this.formInline.surfacePlot = res.data;
          file.onSuccess(res, file);
          message.success("上传成功");
        })
        .catch((err) => {
          message.error("请确保图片大小在2M以内");
        });
    },
    Change(checked) {
      console.log(`a-switch to ${checked}`);
      if (checked === true) {
        this.formInline.isApply = 1;
      } else {
        this.formInline.isApply = 0;
      }
    },
    getDetailsManageList() {
      let id = this.$route.query.id;
      detailsManageList(id).then((res) => {
        this.formInline.activityContent = res.data.activityContent;
        this.formInline.endTime = res.data.endTime;
        this.formInline.startTime = res.data.startTime;
        this.formInline.sortNum = res.data.sortNum;
        this.formInline.surfacePlot = res.data.surfacePlot;
        this.formInline.activityTitle = res.data.activityTitle;
        this.formInline.numberLimit = res.data.numberLimit
      });
    },
    handleSubmit() {},
    onChange(date, dateString) {
      console.log(date, dateString);
      this.formInline.startTime = dateString[0];
      this.formInline.endTime = dateString[1];
    },
    goBack() {
      this.$router.push("/home/eventManagement/eventManagementHome");
    },
    showtable(show) {
      this.show = show;
    },
    save() {
      editManageList(this.formInline).then((res) => {
        message.success(res.data);
        this.$router.push("/home/eventManagement/eventManagementHome");
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/tokenPackage/tokenPackageEditThree.vue